package com.github.jangalinski.tabweb.site.pages

import androidx.compose.runtime.Composable
import com.github.jangalinski.tabweb.Tabweb.buttons
import com.github.jangalinski.tabweb.Tabweb.cardDeck
import com.github.jangalinski.tabweb._foundation.alignment.RIGHT
import com.github.jangalinski.tabweb._foundation.compose.KDiv
import com.github.jangalinski.tabweb._foundation.css.GridWidth
import com.github.jangalinski.tabweb._foundation.size.SmallToLargeX
import com.github.jangalinski.tabweb._foundation.size.smallToLargeX
import com.github.jangalinski.tabweb.button.ButtonColor
import com.github.jangalinski.tabweb.button.ButtonShape
import com.github.jangalinski.tabweb.button.ButtonStyle
import com.github.jangalinski.tabweb.icon.TabwebIcon
import com.github.jangalinski.tabweb.site.SiteRoutes
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames

@Page(routeOverride = SiteRoutes.Buttons)
@Composable
fun ButtonsPage() {
  cardDeck {
    card(width = GridWidth.THIRD) {
      header(title = "Basic")
      body {
        buttons {
          button(text = "Button")
          button(text = "Left icon", icon = TabwebIcon.TI_STAR)
          button(text = "Right icon", icon = TabwebIcon.TI_ARROW_RIGHT, iconPosition = RIGHT)
          button(icon = TabwebIcon.TI_STAR, ariaLabel = "Icon only")
        }
      }
    }
    card(width = GridWidth.THIRD) {
      header(title = "Shapes")
      body {
        buttons {
          button(text = "Default")
          button(text = "Pill", shape = ButtonShape.PILL)
          button(text = "Square", shape = ButtonShape.SQUARE)
          button(icon = TabwebIcon.TI_STAR, ariaLabel = "Default icon")
          button(icon = TabwebIcon.TI_STAR, ariaLabel = "Pill icon", shape = ButtonShape.PILL)
          button(icon = TabwebIcon.TI_STAR, ariaLabel = "Square icon", shape = ButtonShape.SQUARE)
        }
      }
    }
    card(width = GridWidth.THIRD) {
      header(title = "Loading")
      body {
        buttons {
          button(text = "Loading", loading = true)
          button(text = "Disabled", disabled = true)
        }
      }
    }
    card(width = GridWidth.HALF) {
      header(title = "Sizes")
      body {
        KDiv(modifier = Modifier.classNames("space-y")) {
          smallToLargeX.forEach { size ->
            buttons {
              button(text = "Button", size = size)
              button(icon = TabwebIcon.TI_STAR, ariaLabel = "${size.toString().lowercase()} icon", size = size)
              button(text = "Icon", icon = TabwebIcon.TI_STAR, size = size)
            }
          }
        }
      }
    }
    card(width = GridWidth.HALF) {
      header(title = "Standard")
      body {
        buttons {
          ButtonColor.THEME.forEach { color ->
            button(text = color.name.lowercase().replaceFirstChar(Char::uppercase), color = color)
          }
        }
      }
    }
    card(width = GridWidth.FULL) {
      header(title = "Outline")
      body {
        buttons {
          ButtonColor.THEME.forEach { color ->
            button(text = color.name.lowercase().replaceFirstChar(Char::uppercase), color = color, style = ButtonStyle.OUTLINE)
          }
        }
      }
    }
    card(width = GridWidth.FULL) {
      header(title = "Ghost")
      body {
        buttons {
          ButtonColor.THEME.forEach { color ->
            button(text = color.name.lowercase().replaceFirstChar(Char::uppercase), color = color, style = ButtonStyle.GHOST)
          }
        }
      }
    }
    card(width = GridWidth.FULL) {
      header(title = "Pill")
      body {
        buttons {
          ButtonColor.THEME.forEach { color ->
            button(text = color.name.lowercase().replaceFirstChar(Char::uppercase), color = color, shape = ButtonShape.PILL)
          }
        }
      }
    }
    card(width = GridWidth.FULL) {
      header(title = "Square")
      body {
        buttons {
          ButtonColor.THEME.forEach { color ->
            button(text = color.name.lowercase().replaceFirstChar(Char::uppercase), color = color, shape = ButtonShape.SQUARE)
          }
        }
      }
    }
    card(width = GridWidth.FULL) {
      header(title = "Extra colors")
      body {
        buttons {
          ButtonColor.PALETTE.forEach { color ->
            button(text = color.name.lowercase().replaceFirstChar(Char::uppercase), color = color)
          }
        }
      }
    }
    card(width = GridWidth.FULL) {
      header(title = "Social colors")
      body {
        buttons {
          button(text = "Facebook", icon = TabwebIcon.TI_BRAND_FACEBOOK, color = ButtonColor.FACEBOOK)
          button(text = "X", icon = TabwebIcon.TI_BRAND_X, color = ButtonColor.X)
          button(text = "LinkedIn", icon = TabwebIcon.TI_BRAND_LINKEDIN, color = ButtonColor.LINKEDIN)
          button(text = "GitHub", icon = TabwebIcon.TI_BRAND_GITHUB, color = ButtonColor.GITHUB)
          button(text = "YouTube", icon = TabwebIcon.TI_BRAND_YOUTUBE, color = ButtonColor.YOUTUBE)
        }
      }
    }
    card(width = GridWidth.FULL) {
      header(title = "Icon buttons")
      body {
        buttons {
          button(icon = TabwebIcon.TI_BRAND_FACEBOOK, ariaLabel = "Facebook", color = ButtonColor.FACEBOOK)
          button(icon = TabwebIcon.TI_BRAND_TWITTER, ariaLabel = "Twitter", color = ButtonColor.TWITTER)
          button(icon = TabwebIcon.TI_BRAND_X, ariaLabel = "X", color = ButtonColor.X)
          button(icon = TabwebIcon.TI_BRAND_LINKEDIN, ariaLabel = "LinkedIn", color = ButtonColor.LINKEDIN)
          button(icon = TabwebIcon.TI_BRAND_GOOGLE, ariaLabel = "Google", color = ButtonColor.GOOGLE)
          button(icon = TabwebIcon.TI_BRAND_YOUTUBE, ariaLabel = "YouTube", color = ButtonColor.YOUTUBE)
          button(icon = TabwebIcon.TI_BRAND_GITHUB, ariaLabel = "GitHub", color = ButtonColor.GITHUB)
          button(icon = TabwebIcon.TI_BRAND_INSTAGRAM, ariaLabel = "Instagram", color = ButtonColor.INSTAGRAM)
        }
      }
    }
  }
}
